import { render, staticRenderFns } from "./SearchStudentReport.vue?vue&type=template&id=126dde00&scoped=true"
import script from "./SearchStudentReport.vue?vue&type=script&lang=js"
export * from "./SearchStudentReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "126dde00",
  null
  
)

export default component.exports